import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#17C151",
      d: "M12.822 12.002c-.384.913-.923 1.904-1.537 2.894-1.202 1.95-2.622 3.814-3.521 4.935-.895-1.121-2.32-2.986-3.521-4.935-.61-.99-1.153-1.984-1.537-2.894-.388-.93-.578-1.685-.578-2.234a5.64 5.64 0 0 1 5.64-5.64 5.64 5.64 0 0 1 5.64 5.64c0 .55-.191 1.304-.586 2.234m-4.22 8.594c1.81-2.263 5.933-7.748 5.933-10.828A6.77 6.77 0 0 0 7.768 3 6.77 6.77 0 0 0 1 9.768c0 3.08 4.124 8.565 5.932 10.828.434.539 1.237.539 1.67 0"
    }, null, -1)
  ])))
}
export default { render: render }